import React, { useCallback, useEffect } from 'react';

import EventLogPanel from './EventLogPanel';
import { actions, thunk, useAppDispatch, useAppSelector } from 'redux-stores';

export type EventLogProps = {
  organizationId: string;
  isActive: boolean;
  activeSince: number;
};

export default function EventLog({ activeSince, isActive, organizationId }: EventLogProps) {
  const dispatch = useAppDispatch();
  const {
    eventChains,
    eventRetention,
    events,
    eventsError,
    eventsFullyFetched,
    eventsNextPage,
    eventsStatus,
    eventsUnreadable,
  } = useAppSelector((state) => state.offlineMode);

  const load = useCallback(() => {
    thunk.fetchOfflineModeEventLog(dispatch, { organizationId });
  }, [dispatch, organizationId]);

  useEffect(() => {
    load();
    return () => {
      dispatch(actions.clearOfflineModeEvents());
    };
  }, [dispatch, load]);

  const showMore = useCallback(() => {
    thunk.fetchOfflineModeEventLog(
      dispatch,
      eventsNextPage ? { organizationId, cursor: eventsNextPage } : { organizationId }
    );
  }, [dispatch, eventsNextPage, organizationId]);

  return (
    <EventLogPanel
      activeSince={activeSince}
      chains={eventChains}
      error={eventsError}
      events={events}
      isActive={isActive}
      isFullyFetched={eventsFullyFetched}
      onRetry={load}
      onShowMore={showMore}
      retention={eventRetention}
      status={eventsStatus}
      unreadable={eventsUnreadable}
    />
  );
}
